export * from './migrationCardInfoDossier.component';
